import React, { useState, useEffect } from 'react'
import { Button, Flex, message, Spin, Input, notification, Row, Col, Drawer, Tag, Popconfirm } from 'antd';
import { DeleteFilled } from '@ant-design/icons'
import InputFormByObject from '../common/dynamic-form/InputFormByObject';
import UIObject from '../common/dynamic-form/UIObject';
import BaseGameObject from '../objects/BaseGameObject';
import { isMobile } from 'react-device-detect';
import { searchInObject } from '../common/Search';


import dayjs from 'dayjs';
import { useSchool } from '../hook/SchoolHook';
import SchoolObject from '../objects/SchoolObject';


export default function SC05_School(props) {
    const { schools, updateSchool, addNewSchool, deleteSchool } = useSchool();
    const [schoolList, setSchoolList] = useState(null);
    const [schoolSelected, setSchoolSelected] = useState(new SchoolObject({}))
    const [isEditMode, setIsEditMode] = useState(false);
    const [finalData, setFinalData] = useState(null);
    const [open, setOpen] = useState(false);
    // const [messageApi, contextHolder] = message.useMessage();
    const [api, contextHolder] = notification.useNotification();
    const [textSearch, setTextSearch] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (schools && Array.isArray(schools))
            setSchoolList(schools)
    }, [schools])

    const createNewSchool = () => {
        setSchoolSelected(null)
        setIsEditMode(false)
        const newGame = new SchoolObject({});
        newGame.addHiddenField('key');
        setSchoolSelected(newGame)
        setOpen(true);
    }

    const updateInfo = (school) => {
        setSchoolSelected(school)
        setIsEditMode(true)
    }

    const onClose = () => {
        setSchoolSelected(null)
        setOpen(false);
    };
    const error = (message) => {
        api['error']({
            message: "Chỉnh sửa thông tin trường học thất bại!",
            description: message,
            zIndexPopup: 99999,
            duration: 10
        })
    };


    const openSuccessNoti = (name) => {
        console.log("SUCCESS UPDATE SCHOOL =============")
        const content = <Flex vertical>
            <div>Hãy kiểm tra lại thông tin của trường học mới tạo để đảm bảo không nhầm lẫn</div>
            <Flex justify='space-evenly' style={{ fontWeight: "bold" }} ><div>Tên trường: </div><div>{name}</div></Flex>
        </Flex>
        api.success({
            message: `Chúc mừng bạn đã ${isEditMode ? "chỉnh sửa thông tin" : "tạo mới"} trường học thành công!`,
            duration: 0,
            zIndexPopup: 99999,
            description: content,
            width: '680px'
        })
    };

    const onSubmit = async (values) => {
        if (finalData) {
            let res = await updateSchool(finalData);
            if (!res.error) {
                // messageApi.success("Update User successful!")
                openSuccessNoti(values.name)
                setFinalData(null)
                setOpen(false)
            } else error(`Lưu trữ thất bại: "${res.message}"`)
        }
    }

    const startDeleteSchool = async (school) => {
        setIsLoading(true)
        const res = await deleteSchool(school);
        if (res.success) {
            api.success({
                message: `Thành công!`,
                duration: 0,
                zIndexPopup: 99999,
                description: `Xóa trường học ${school.name} (${school.id}) thành công`,
                width: '450px'
            })
        } else {
            api['error']({
                message: "Xóa trường học thất bại",
                description: res.message,
                zIndexPopup: 99999,
                duration: 10
            })
        }
        setIsLoading(false);
    }

    const dataSource = searchInObject(schoolList, textSearch);

    return (
        <>
            {contextHolder}
            <Flex style={{ marginBottom: '20px' }} justify='space-between' wrap gap={"small"}>
                <div style={{ fontStyle: 'italic', fontSize: '11pt' }}>Danh sách trường học: </div>
                <Input placeHolder="Tìm kiếm" onChange={(e) => {
                    setTextSearch(e.target.value);
                    console.log("TEXT: ", e.target.value);
                }} style={{ width: "300px" }} />
                <Button type='primary' onClick={createNewSchool}>Tạo mới</Button>
            </Flex>
            <Flex vertical gap={'0px'}>
                {
                    isMobile ?
                        null :
                        <Row style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                            <Col
                                xs={{ flex: '100%' }}
                                sm={{ flex: '100%' }}
                                md={{ flex: '40%' }}
                                lg={{ flex: '10%' }}
                                xl={{ flex: '10%' }}>Mã trường học</Col>
                            <Col
                                xs={{ flex: '100%' }}
                                sm={{ flex: '100%' }}
                                md={{ flex: '40%' }}
                                lg={{ flex: '25%' }}
                                xl={{ flex: '25%' }}>Tên trường học</Col>
                            <Col
                                xs={{ flex: '100%' }}
                                sm={{ flex: '100%' }}
                                md={{ flex: '40%' }}
                                lg={{ flex: '14%' }}
                                xl={{ flex: '14%' }}>Tên Hiệu trưởng</Col>
                            <Col
                                xs={{ flex: '100%' }}
                                sm={{ flex: '100%' }}
                                md={{ flex: '40%' }}
                                lg={{ flex: '12%' }}
                                xl={{ flex: '12%' }}>Số điện thoại</Col>
                            <Col
                                xs={{ flex: '100%' }}
                                sm={{ flex: '100%' }}
                                md={{ flex: '40%' }}
                                lg={{ flex: '24%' }}
                                xl={{ flex: '24%' }}>Địa chỉ</Col>
                            <Col
                                xs={{ flex: '100%' }}
                                sm={{ flex: '100%' }}
                                md={{ flex: '40%' }}
                                lg={{ flex: '15%' }}
                                xl={{ flex: '15%' }}>Ghi chú</Col>
                        </Row>
                }
                {
                    dataSource == null ?
                        <Spin />
                        : ((Array.isArray(dataSource) && dataSource.length > 0) ?
                            dataSource.map((school, index) => {
                                return (
                                    <Flex key={index} style={{ width: "100%", alignItems: 'center', backgroundColor: index % 2 == 0 ? "#f0f5ff" : "white" }}>
                                        <Row
                                            className='customer-info'
                                            wrap={true}
                                            style={{ width: "-webkit-fill-available", minHeight: '45px', alignContent: 'center', margin: 0, paddingTop: "5px", paddingBottom: '5px', cursor: 'pointer' }}
                                            onClick={e => {
                                                const iSchool = new SchoolObject(school)
                                                iSchool.addHiddenField('key')
                                                setIsEditMode(true)
                                                setSchoolSelected(iSchool)
                                                setOpen(true)
                                            }}>
                                            {
                                                isMobile ?
                                                    <Col xs={{ flex: '100%' }}><b>{school.name}</b> <i>({school.id})</i></Col>
                                                    : [
                                                        <Col
                                                            xs={{ flex: '100%' }}
                                                            sm={{ flex: '100%' }}
                                                            md={{ flex: '40%' }}
                                                            lg={{ flex: '10%' }}
                                                            xl={{ flex: '10%' }}>{school.id}</Col>,
                                                        <Col
                                                            xs={{ flex: '100%' }}
                                                            sm={{ flex: '100%' }}
                                                            md={{ flex: '40%' }}
                                                            lg={{ flex: '25%' }}
                                                            xl={{ flex: '25%' }}><b>{school.name}</b></Col>
                                                    ]
                                            }
                                            {
                                                isMobile ?
                                                    <Col xs={{ flex: '100%' }}><i>Hiệu trưởng: </i><b>{school.htName}</b> ({school.phone})</Col>
                                                    : [
                                                        <Col
                                                            xs={{ flex: '100%' }}
                                                            sm={{ flex: '100%' }}
                                                            md={{ flex: '40%' }}
                                                            lg={{ flex: '14%' }}
                                                            xl={{ flex: '14%' }}>{school.htName}</Col>,
                                                        <Col
                                                            xs={{ flex: '100%' }}
                                                            sm={{ flex: '100%' }}
                                                            md={{ flex: '40%' }}
                                                            lg={{ flex: '12%' }}
                                                            xl={{ flex: '12%' }}>{school.phone}</Col>
                                                    ]
                                            }

                                            <Col
                                                xs={{ flex: '100%' }}
                                                sm={{ flex: '100%' }}
                                                md={{ flex: '40%' }}
                                                lg={{ flex: '24%' }}
                                                xl={{ flex: '24%' }}><i>{isMobile ? "Địa chỉ: " : ""}</i>{school.address}</Col>
                                            <Col
                                                xs={{ flex: '100%' }}
                                                sm={{ flex: '100%' }}
                                                md={{ flex: '40%' }}
                                                lg={{ flex: '15%' }}
                                                xl={{ flex: '15%' }}><i>{isMobile ? "Ghi chú: " : ""}</i>{school.note}</Col>
                                        </Row>
                                        {
                                            isLoading?<Spin/>:
                                            <Popconfirm
                                                title="Xóa trường học này!"
                                                description="Hành động này không thể khôi phục. Bạn có chắc chắn muốn xóa trường học này?"
                                                onConfirm={(e) => { startDeleteSchool(school) }}
                                                // onCancel={cancel}
                                                okText="Đồng ý xóa"
                                                cancelText="Quay lại"
                                            >
                                                <Button icon={<DeleteFilled />} danger></Button>
                                            </Popconfirm>

                                        }
                                    </Flex>

                                );
                            })
                            : <div>Không tìm thấy trường học nào</div>)
                }
            </Flex>
            <Drawer
                title={isEditMode ? "Chỉnh sửa thông tin trường học" : "Thêm mới trường học"}
                placement="right"
                width={isMobile ? "420px" : "80vw"}
                onClose={onClose}
                open={open}
            >
                <div style={{ width: "100%" }}>
                    {schoolSelected ?
                        <div style={{ width: "60%", minWidth: "340px" }}>
                            <div style={{ fontWeight: "bold", fontSize: "12pt", marginBottom: "10px" }}>THÔNG TIN TRƯỜNG HỌC</div>
                            <InputFormByObject submitButton="Lưu" uiObject={schoolSelected} onSubmit={onSubmit} onChange={(data) => { setFinalData(data); console.log("INPUT FORM CHANGED TO: ", data) }} />
                        </div>
                        : null}

                </div>
            </Drawer>
        </>
    )
}